import React from 'react'

interface IframeProps {
  src: string
  className?: string
  allowFullScreen?: boolean
  allowTransparency?: boolean
}

const Iframe: React.FC<IframeProps> = props => {
  const { src, allowFullScreen, allowTransparency, className } = props
  return (
    <iframe
      title="iframe"
      className={className}
      src={src}
      allowTransparency={allowTransparency}
      frameBorder="0"
      scrolling="no"
      allowFullScreen={allowFullScreen}
    />
  )
}

export default Iframe
